/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Totalchangeslabel2Inputs */

const id_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const ms_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const da_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringer`)
};

const de_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen`)
};

const en_us2_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

const es_es2_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const es_mx2_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fil_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pagbabago`)
};

const fr_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications`)
};

const it_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche`)
};

const hu_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változások`)
};

const nl_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingen`)
};

const no_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringer`)
};

const pl_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiany`)
};

const pt_br2_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudanças`)
};

const pt_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações`)
};

const ro_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări`)
};

const fi_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutokset`)
};

const sv_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringar`)
};

const vi_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi`)
};

const tr_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklikler`)
};

const cs_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny`)
};

const bg_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промени`)
};

const ru_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения`)
};

const uk_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміни`)
};

const ar_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغييرات`)
};

const hi_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन`)
};

const th_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลง`)
};

const ja_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更数`)
};

const zh_cn2_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`变更记录`)
};

const zh_hant1_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更記錄`)
};

const ko_sandboxes_totalchangeslabel2 = /** @type {(inputs: Sandboxes_Totalchangeslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 사항`)
};

/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Sandboxes_Totalchangeslabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_totalchangeslabel2 = /** @type {((inputs?: Sandboxes_Totalchangeslabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Totalchangeslabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_totalchangeslabel2(inputs)
	if (locale === "ms") return ms_sandboxes_totalchangeslabel2(inputs)
	if (locale === "da") return da_sandboxes_totalchangeslabel2(inputs)
	if (locale === "de") return de_sandboxes_totalchangeslabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_totalchangeslabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_totalchangeslabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_totalchangeslabel2(inputs)
	if (locale === "fil") return fil_sandboxes_totalchangeslabel2(inputs)
	if (locale === "fr") return fr_sandboxes_totalchangeslabel2(inputs)
	if (locale === "it") return it_sandboxes_totalchangeslabel2(inputs)
	if (locale === "hu") return hu_sandboxes_totalchangeslabel2(inputs)
	if (locale === "nl") return nl_sandboxes_totalchangeslabel2(inputs)
	if (locale === "no") return no_sandboxes_totalchangeslabel2(inputs)
	if (locale === "pl") return pl_sandboxes_totalchangeslabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_totalchangeslabel2(inputs)
	if (locale === "pt") return pt_sandboxes_totalchangeslabel2(inputs)
	if (locale === "ro") return ro_sandboxes_totalchangeslabel2(inputs)
	if (locale === "fi") return fi_sandboxes_totalchangeslabel2(inputs)
	if (locale === "sv") return sv_sandboxes_totalchangeslabel2(inputs)
	if (locale === "vi") return vi_sandboxes_totalchangeslabel2(inputs)
	if (locale === "tr") return tr_sandboxes_totalchangeslabel2(inputs)
	if (locale === "cs") return cs_sandboxes_totalchangeslabel2(inputs)
	if (locale === "bg") return bg_sandboxes_totalchangeslabel2(inputs)
	if (locale === "ru") return ru_sandboxes_totalchangeslabel2(inputs)
	if (locale === "uk") return uk_sandboxes_totalchangeslabel2(inputs)
	if (locale === "ar") return ar_sandboxes_totalchangeslabel2(inputs)
	if (locale === "hi") return hi_sandboxes_totalchangeslabel2(inputs)
	if (locale === "th") return th_sandboxes_totalchangeslabel2(inputs)
	if (locale === "ja") return ja_sandboxes_totalchangeslabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_totalchangeslabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_totalchangeslabel2(inputs)
	return ko_sandboxes_totalchangeslabel2(inputs)
});
export { sandboxes_totalchangeslabel2 as "sandboxes.totalChangesLabel" }